import { getDomain, getSiteMode } from '@wt/utilities/siteMode';

type CommandArray = Array<(this: typeof globalThis) => void> | undefined;
declare global {
  interface Window {
    snigelPubConf: {
      adengine: {
        activeAdUnits: string[];
      };
    };
    dataLayer?: any;
    activeUnits?: string[];
    adngin?: {
      adnginLoaderReady?: boolean;
      cmd: {
        startAuction: (any: any) => void;
      };
      queue?: CommandArray;
    };
    destroyRefreshTopAd?: any;
    gtag?: any;
    adconsent: (
      arg0: string,
      arg1?: any,
      arg2?: (consent: any, success: any) => any
    ) => void;
    __tcfapi: (
      arg0: string,
      arg1: number,
      arg2: (tcData: any, success: any) => void
    ) => void;
    admiral?: (...args: any[]) => void;
  }
}

// mobile and desktop
export function refreshBannerAd() {
  if (
    window.adngin !== undefined &&
    window.adngin.cmd !== undefined &&
    typeof window.adngin.cmd.startAuction === 'function'
  ) {
    window.adngin.cmd.startAuction(['top_banner']);
  }
}

// mobile and desktop
export function destroyBannerAd() {
  if (
    window.adngin !== undefined &&
    document.getElementById('adngin-top_banner-0')
  ) {
    Array.from(window.googletag.pubads().getSlots()).forEach((slot) => {
      if (slot.getSlotElementId() === 'adngin-top_banner-0') {
        window.googletag.destroySlots([slot]);
      }
    });
  }
}

// desktop
export function refreshSidebarAd() {
  if (window.innerWidth < 1024) return;
  if (
    window.adngin !== undefined &&
    window.adngin.cmd !== undefined &&
    typeof window.adngin.cmd.startAuction === 'function'
  ) {
    window.adngin.cmd.startAuction(['sidebar', 'sidebar_bottom']);
  }
}

// desktop
export function refreshVideoAd() {
  if (window.innerWidth < 1024) return;
  if (
    window.adngin !== undefined &&
    window.adngin.cmd !== undefined &&
    typeof window.adngin.cmd.startAuction === 'function'
  ) {
    window.adngin.cmd.startAuction(['video']);
  }
}

// desktop
export function destroyVideoAd() {
  if (window.innerWidth < 1024) return;
  if (
    window.adngin !== undefined &&
    document.getElementById('adngin-video-0')
  ) {
    Array.from(window.googletag.pubads().getSlots()).forEach((slot) => {
      if (slot.getSlotElementId() === 'adngin-video-0') {
        window.googletag.destroySlots([slot]);
      }
    });
  }
}

// desktop
export function refreshArchiveSidebarAd() {
  if (window.innerWidth < 1200) return;
  if (
    window.adngin !== undefined &&
    window.adngin.cmd !== undefined &&
    typeof window.adngin.cmd.startAuction === 'function'
  ) {
    window.adngin.cmd.startAuction(['archive_sidebar']);
  }
}

const getAdUrl = () => {
  const siteMode = getSiteMode();
  const url =
    siteMode == 'whentaken-movies'
      ? 'movies.whentaken.com'
      : siteMode == 'wheretaken'
        ? 'wheretaken.com'
        : 'whentaken.com';
  return url;
};

export function getAdScript(): HTMLScriptElement {
  const href = window.location.href;
  let src = '';
  const url = getAdUrl();
  if (
    href.includes('staging') ||
    href.includes('localhost') ||
    href.includes('pages.dev')
  ) {
    console.log('Loading STAGING ads script');
    src = `https://staging-cdn.snigelweb.com/adengine/${url}/loader.js`;
  } else {
    console.log('Loading LIVE ads script');
    src = `https://cdn.snigelweb.com/adengine/${url}/loader.js`;
  }

  const node = document.createElement('script');
  node.src = src;
  node.type = 'text/javascript';
  node.async = true;
  node.setAttribute('data-cfasync', 'false');
  return node;
}

/**
 * Loads ad script and sets active ad units.
 * For Premium users ad script needs to be loaded so we can get consent, but active units should be empty so no ads appear.
 * For non premium users, ad script needs to be loaded with correct active ad units.
 */
export function loadAdScript(isPremium: boolean): void {
  try {
    // set active ad units
    setActiveAdUnits(isPremium);

    // load ad script
    const node = getAdScript();
    const url = getAdUrl();
    if (!document.querySelector(`script[src*="adengine/${url}/loader.js`)) {
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  } catch (e) {
    console.log('error loading ad script: ', e);
  }
}

function getActiveAdUnits(): {
  activeAdUnits: string[];
  targeting?: {
    key1: number;
  };
} {
  const siteMode = getSiteMode();
  let breakpoint = 'small';

  const w = window.innerWidth;

  breakpoint = w > 1024 ? 'medium' : breakpoint;
  breakpoint = w > 1690 ? 'large' : breakpoint;

  let activeUnits: string[] = [];
  let targeting;

  switch (breakpoint.toLowerCase()) {
    case 'small':
      switch (siteMode) {
        case 'whentaken':
          activeUnits = ['mobile_mrec', 'top_banner'];
          break;
        case 'wheretaken':
          activeUnits = ['top_banner'];
          break;
        case 'whentaken-movies':
          activeUnits = ['top'];
          break;
      }
      break;
    case 'medium':
      switch (siteMode) {
        case 'whentaken':
          activeUnits = [
            'video',
            'sidebar',
            'sidebar_bottom',
            'top_banner',
            'archive_sidebar',
          ];
          targeting = {
            key1: 1,
          };
          break;
        case 'wheretaken':
          activeUnits = ['video', 'sidebar', 'top_banner', 'archive_sidebar'];
          targeting = {
            key1: 1,
          };
          break;
        case 'whentaken-movies':
          activeUnits = ['video', 'side_1', 'top', 'archive_sidebar'];
          targeting = {
            key1: 1,
          };
          break;
      }
      break;
    case 'large':
      switch (siteMode) {
        case 'whentaken':
          activeUnits = [
            'video',
            'sidebar',
            'sidebar_bottom',
            'top_banner',
            'archive_sidebar',
          ];
          break;
        case 'wheretaken':
          activeUnits = ['video', 'sidebar', 'top_banner', 'archive_sidebar'];
          break;
        case 'whentaken-movies':
          activeUnits = ['video', 'side_1', 'top', 'archive_sidebar'];
          break;
      }
      break;
  }

  return {
    activeAdUnits: activeUnits,
    targeting,
  };
}

function setActiveAdUnits(isPremium: boolean): void {
  if (isPremium) {
    window.snigelPubConf = {
      adengine: {
        activeAdUnits: [''],
      },
    };
    return;
  }

  const activeUnits = getActiveAdUnits();

  window.snigelPubConf = {
    adengine: activeUnits,
  };
}

/**
 * Check for consent through Snigel, then set GA consent
 */
export const checkForConsent = () => {
  window.addEventListener('adnginLoaderReady', function () {
    window.adconsent &&
      window.adconsent('getConsent', null, function (consent, success) {
        if (success) {
          if (consent.fullConsent) {
            console.log('########### yas consent');
            window.gtag('consent', 'update', {
              ad_storage: 'granted',
              analytics_storage: 'granted',
              ad_user_data: 'granted',
              ad_personalization: 'granted',
            });
          } else {
            console.log('########### naur consent');
            clearAnalyticsCookies();
          }
        }
      });
  });
};

export function clearAnalyticsCookies(): void {
  const teuteufCookieNames = ['_gid', '_ttp', '_tt_enable_cookie'];
  const tiktokCookieNames = ['_ttp'];

  // delete all _ga cookies
  document.cookie
    .split(';')
    .map((c) => c.trim())
    .forEach((cookie) => {
      const name = cookie.split('=')[0];
      if (name.startsWith('_ga')) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getDomain()}`;
      }
    });

  // delete other analytics cookies
  teuteufCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=${getDomain()}`;
  });
  tiktokCookieNames.forEach((name) => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.tiktok.com;`;
  });
}
